(function () {
  const BEE_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 36 36" fill="none">
      <g class="ik-bee-wing-left">
        <path d="M15 17C10 18 5 24 11 26C14.5 25.5 16.5 20.5 16 17.5Z" fill="#F5E5C9" fill-opacity="0.9" stroke="#E0B364" stroke-width="0.8"/>
      </g>
      <g class="ik-bee-wing-right">
        <path d="M21 17C26 18 31 24 25 26C21.5 25.5 19.5 20.5 20 17.5Z" fill="#F5E5C9" fill-opacity="0.9" stroke="#E0B364" stroke-width="0.8"/>
      </g>
      <ellipse cx="18" cy="21" rx="5" ry="7.5" fill="#E0B364"/>
      <path d="M13.5 19H22.5M13 21.5H23M14 24H22" stroke="#1A140E" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M18 28.5L18 31" stroke="#E0B364" stroke-width="1.4" stroke-linecap="round"/>
      <circle cx="18" cy="15" r="3.2" fill="#1A140E" stroke="#E0B364" stroke-width="0.8"/>
      <circle cx="18" cy="9.5" r="2.8" fill="#1A140E" stroke="#E0B364" stroke-width="0.8"/>
      <path d="M16.2 7.8L14 5.2M19.8 7.8L22 5.2" stroke="#F5E5C9" stroke-width="1.2" stroke-linecap="round"/>
    </svg>
  `;

  function initBees() {
    // Only Desktop Mouse Trailing Bee Follower
    if (window.innerWidth >= 992 && !window.matchMedia('(pointer: coarse)').matches) {
      if (document.querySelector('.ik-bee-follower')) return;

      const bee = document.createElement('div');
      bee.className = 'ik-bee-follower';
      bee.innerHTML = BEE_SVG;
      document.body.appendChild(bee);

      let mouseX = window.innerWidth / 2;
      let mouseY = window.innerHeight / 2;
      let beeX = window.innerWidth / 2;
      let beeY = -120; // Clearly outside the top screen edge
      let currentAngle = 180;
      let hasMoved = false;
      let startTime = 0;
      const ENTRANCE_DURATION = 2200; // 2.2 seconds ultra-gentle entrance

      // Position initially above viewport
      bee.style.transform = `translate3d(${beeX - 16}px, ${beeY - 16}px, 0) rotate(${currentAngle}deg)`;

      window.addEventListener('mousemove', function (e) {
        mouseX = e.clientX;
        mouseY = e.clientY;

        if (!hasMoved) {
          hasMoved = true;
          startTime = performance.now();

          const winWidth = window.innerWidth;
          // If mouse is on the left half of the screen, spawn from top-right.
          // If mouse is on the right half, spawn from top-left.
          if (mouseX < winWidth / 2) {
            beeX = Math.min(winWidth + 40, mouseX + winWidth * 0.45);
          } else {
            beeX = Math.max(-40, mouseX - winWidth * 0.45);
          }
          beeY = -120;

          const initDx = mouseX - beeX;
          const initDy = mouseY - beeY;
          currentAngle = Math.atan2(initDy, initDx) * (180 / Math.PI) + 90;

          bee.style.transform = `translate3d(${beeX - 16}px, ${beeY - 16}px, 0) rotate(${currentAngle}deg)`;
          bee.classList.add('ik-bee-visible');
        }
      }, { passive: true });

      document.addEventListener('mouseleave', function () {
        bee.classList.remove('ik-bee-visible');
        hasMoved = false;
        beeY = -120;
        const cards = document.querySelectorAll('.liquid-glass-card, [data-ik-glass-card], .multi-column__column');
        cards.forEach(card => card.style.setProperty('--bee-opacity', '0'));
        const titles = document.querySelectorAll('.ik-spotlight-heading, [data-ik-spotlight-heading], .ik-hero-heading, .imker-hero h1');
        titles.forEach(title => {
          title.style.setProperty('--bee-x', '-999px');
          title.style.setProperty('--bee-y', '-999px');
          title.style.setProperty('--bee-title-opacity', '0');
        });
        const footers = document.querySelectorAll('.footer, footer, #shopify-section-footer');
        footers.forEach(foot => foot.style.setProperty('--bee-opacity', '0'));
      });

      document.addEventListener('mouseenter', function (e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
      });

      function animateFollower() {
        if (hasMoved) {
          // Ultra-slow initial start with smooth power-curve acceleration over 2.2s
          const elapsed = performance.now() - startTime;
          const progress = Math.min(1, Math.max(0, elapsed / ENTRANCE_DURATION));
          const easeIn = Math.pow(progress, 2.5); // Starts very slow (0.003) and curves smoothly upwards

          const ease = 0.003 + (0.19 - 0.003) * easeIn;
          const rotEase = 0.02 + (0.22 - 0.02) * easeIn;

          const dx = mouseX - beeX;
          const dy = mouseY - beeY;
          const dist = Math.hypot(dx, dy);

          const targetDistanceOffset = 32;

          if (dist > 1) {
            const angleRad = Math.atan2(dy, dx);
            const targetX = mouseX - Math.cos(angleRad) * targetDistanceOffset;
            const targetY = mouseY - Math.sin(angleRad) * targetDistanceOffset;

            const targetDx = targetX - beeX;
            const targetDy = targetY - beeY;

            beeX += targetDx * ease;
            beeY += targetDy * ease;

            const targetAngle = angleRad * (180 / Math.PI) + 90;

            let diff = (targetAngle - currentAngle) % 360;
            if (diff < -180) diff += 360;
            if (diff > 180) diff -= 360;

            currentAngle += diff * rotEase;
          }

          bee.style.transform = `translate3d(${beeX - 16}px, ${beeY - 16}px, 0) rotate(${currentAngle}deg)`;

          // Feed exact live BEE coordinates & proximity to glass cards
          const cards = document.querySelectorAll('.liquid-glass-card, [data-ik-glass-card], .multi-column__column');
          cards.forEach((card) => {
            const rect = card.getBoundingClientRect();
            if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;

            const bx = beeX - rect.left;
            const by = beeY - rect.top;

            let distX = 0;
            if (beeX < rect.left) distX = rect.left - beeX;
            else if (beeX > rect.right) distX = beeX - rect.right;

            let distY = 0;
            if (beeY < rect.top) distY = rect.top - beeY;
            else if (beeY > rect.bottom) distY = beeY - rect.bottom;

            const distToCard = Math.hypot(distX, distY);
            const MAX_RADIUS = 280; // Distance in pixels where glow gently emerges

            let opacity = 0;
            if (distToCard < MAX_RADIUS) {
              const factor = 1 - (distToCard / MAX_RADIUS);
              opacity = Math.pow(factor, 1.4);
            }

            card.style.setProperty('--bee-x', `${bx.toFixed(1)}px`);
            card.style.setProperty('--bee-y', `${by.toFixed(1)}px`);
            card.style.setProperty('--bee-opacity', opacity.toFixed(3));
          });

          // Feed exact live BEE coordinates directly to all spotlight headings
          const titles = document.querySelectorAll('.ik-spotlight-heading, [data-ik-spotlight-heading], .ik-hero-heading, .imker-hero h1');
          titles.forEach((title) => {
            const rect = title.getBoundingClientRect();
            if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;

            const bx = beeX - rect.left;
            const by = beeY - rect.top;

            let distX = 0;
            if (beeX < rect.left) distX = rect.left - beeX;
            else if (beeX > rect.right) distX = beeX - rect.right;

            let distY = 0;
            if (beeY < rect.top) distY = rect.top - beeY;
            else if (beeY > rect.bottom) distY = beeY - rect.bottom;

            const distToTitle = Math.hypot(distX, distY);
            const MAX_TITLE_RADIUS = 260;

            let opacity = 0;
            if (distToTitle < MAX_TITLE_RADIUS) {
              const factor = 1 - (distToTitle / MAX_TITLE_RADIUS);
              opacity = Math.pow(factor, 1.3);
            }

            title.style.setProperty('--bee-x', `${bx.toFixed(1)}px`);
            title.style.setProperty('--bee-y', `${by.toFixed(1)}px`);
            title.style.setProperty('--bee-title-opacity', opacity.toFixed(3));
          });

          // Feed exact live BEE coordinates & proximity to footers
          const footers = document.querySelectorAll('.footer, footer, #shopify-section-footer');
          footers.forEach((foot) => {
            const rect = foot.getBoundingClientRect();
            if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;

            const bx = beeX - rect.left;
            const by = beeY - rect.top;

            let distX = 0;
            if (beeX < rect.left) distX = rect.left - beeX;
            else if (beeX > rect.right) distX = beeX - rect.right;

            let distY = 0;
            if (beeY < rect.top) distY = rect.top - beeY;
            else if (beeY > rect.bottom) distY = beeY - rect.bottom;

            const distToFoot = Math.hypot(distX, distY);
            const MAX_FOOTER_RADIUS = 360;

            let opacity = 0;
            if (distToFoot < MAX_FOOTER_RADIUS) {
              const factor = 1 - (distToFoot / MAX_FOOTER_RADIUS);
              opacity = Math.pow(factor, 1.3);
            }

            foot.style.setProperty('--bee-x', `${bx.toFixed(1)}px`);
            foot.style.setProperty('--bee-y', `${by.toFixed(1)}px`);
            foot.style.setProperty('--bee-opacity', opacity.toFixed(3));
          });
        }

        requestAnimationFrame(animateFollower);
      }

      requestAnimationFrame(animateFollower);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBees);
  } else {
    initBees();
  }
})();
